import Mkt from '@pages/Mkt/index';
import { RouteObject } from 'react-router';
import AppLayout from '@pages/_layout/AppLayout';

export default [
  {
    path: 'mkt',
    element: <AppLayout />,
    children: [{ index: true, element: <Mkt /> }],
  },
] as RouteObject[];
